import { LoomSiteAri } from '@atlassian/ari';

import { AggRelayEnvironment, createRelayResource } from '@townsquare/relay-utils';
import { ResourceContext } from '@townsquare/router';
import { getIsExperimentEnabledWithoutExposure } from '@townsquare/stat-sig';
import { DISCOVER_FEED_EXPERIMENT } from '@townsquare/stat-sig/experiments';
import { isGateEnabled } from '@townsquare/stat-sig/gate';

import LoomFeedListQuery, {
  LoomFeedListQuery as LoomFeedListQueryType,
} from '../components/feed/__generated__/LoomFeedListQuery.graphql';

export const loomFeedResource = createRelayResource<LoomFeedListQueryType>({
  getQuery: (_, resourceStoreContext) => {
    const context = resourceStoreContext as ResourceContext;
    const cloudId = context.collabContext?.rovoWorkspace;

    const isEnabled =
      !!cloudId &&
      getIsExperimentEnabledWithoutExposure(DISCOVER_FEED_EXPERIMENT) &&
      isGateEnabled('townsquare_enable_loom_feed');

    return {
      query: LoomFeedListQuery,
      variables: {
        loomSiteAri: cloudId ? LoomSiteAri.create({ siteId: cloudId }).toString() : '',
        isEnabled,
      },
      environment: AggRelayEnvironment,
    };
  },
  maxAge: 60_000 * 30, // 30 minute cache during the SPA session to avoid flickering
});
